<div mat-dialog-content>
  <p class="naskh">{{ "LOGIN.WELCOME_TEXT" | translate }}</p>
  <p class="naskh">
    {{ "LOGIN.WELCOME_TEXT_2" | translate }} <mat-icon>ondemand_video</mat-icon>
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">
    {{ "LOGIN.CONTINUE" | translate }}
  </button>
</div>
